var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPriorityLow = function SvgPriorityLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3182CE",
    d: "M1.757.637.343 2.05 6 7.708l5.656-5.657L10.243.637 6 4.879z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3182CE",
    d: "m.343 7.708 1.414-1.414L6 10.536l4.242-4.242 1.414 1.414L6 13.365z"
  })));
};
export default SvgPriorityLow;